import { gql } from '@apollo/client';
export const EXPORT_FIELDS = gql `
  fragment ExportFields on Export {
    id
    createdAt
    updatedAt
    clientId
    name
    entityType
    filterId
    integrationConfigId
    isActive
    sendEmptyFile
    notifyNoFileSent
    lastRunStatus
    lastRunAt
    cronSchedules
    publicKey
    shortName
    filenamePattern
    extension
    startDate
    daysApart
    notifyExternalEmails
    rangeOffsetDays
    extraData {
      processAllClients
      childClientIds
      aggregatePaymentRequestItems
    }
  }
`;
export const EXPORTS = gql `
  ${EXPORT_FIELDS}
  query EXPORTS($spec: ExportSpec!) {
    exports(spec: $spec) {
      ...ExportFields
    }
  }
`;
export const GET_EXPORT = gql `
  ${EXPORT_FIELDS}
  query GET_EXPORT($id: Int!) {
    getExport(id: $id) {
      ...ExportFields
      exportFields {
        id
        createdAt
        updatedAt
        clientId
        fieldId
        columnName
        sortOrder
        valueMappings
        defaultValue
      }
    }
  }
`;
export const SAVE_EXPORT = gql `
  ${EXPORT_FIELDS}
  mutation SAVE_EXPORT($input: ExportInput!) {
    saveExport(input: $input) {
      ...ExportFields
    }
  }
`;
export const DELETE_EXPORT = gql `
  ${EXPORT_FIELDS}
  mutation DELETE_EXPORT($id: Int!) {
    deleteExport(id: $id) {
      ...ExportFields
    }
  }
`;
